import { Component } from "@angular/core";

import { HttpErrorResponse } from "@angular/common/http";
import { NzMessageService, NzNotificationService } from "ng-zorro-antd";

import {
  GlobalComponent,
  Dipendente,
  Result,
  Aziende,
} from "../../environments/global";

@Component({
  selector: "app-dipendenti",
  templateUrl: "dipendenti.component.html",
  styleUrls: ["dipendenti.component.scss"],
})
export class DipendentiComponent {
  // TABLE VARS
  dataSet = [];
  public displayData = [...this.dataSet];
  editCache = {};
  sortName = null;
  sortValue = null;
  // COMPONENT VARS
  newDipendente: Dipendente = {
    code: "",
    name: "",
    surname: "",
    company: null,
    email: "",
    rfid: "",
  } as Dipendente;
  public newCodeError: string = "validating";
  isLoading: boolean = true;
  companyData: Array<string> = Aziende;

  constructor(
    public g: GlobalComponent,
    private notification: NzNotificationService,
    private message: NzMessageService
  ) {
    // SETUP INTERFACE
    this.g.menuState = 1;
    this.g.homeTitle = "Tabella Dipendenti";

    // LOAD DATA
    this.loadData();
  }
  loadData() {
    this.isLoading = true;
    const query: string = "SELECT * from chk_users";
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        this.dataSet = res.data;
        this.updateEditCache();
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    if (this.sortName) {
      this.displayData = [
        ...this.dataSet.sort((a, b) =>
          this.sortValue === "ascend"
            ? a[this.sortName] > b[this.sortName]
              ? 1
              : -1
            : b[this.sortName] > a[this.sortName]
            ? 1
            : -1
        ),
      ];
    } else {
      this.displayData = [...this.dataSet];
    }
  }

  startEdit(id: string): void {
    this.editCache[id].edit = true;
  }

  cancelEdit(id: string): void {
    this.editCache[id].edit = false;
  }

  saveNew(): void {
    const check = this.dataSet.findIndex(
      (item) => item.code === this.newDipendente.code
    );
    if (check !== -1) {
      this.notification.error(
        "Codice già esistente",
        "Attenzione: il codice inserito è già stato utilizzato.",
        { nzDuration: this.g.fastTime }
      );
      this.newCodeError = "error";
      return;
    }

    const query: string =
      'INSERT INTO chk_users (`code`, `name`, `surname`, `company`, `email`, `rfid`) VALUES ("' +
      this.newDipendente.code +
      '","' +
      this.newDipendente.name +
      '","' +
      this.newDipendente.surname +
      '","' +
      this.newDipendente.company +
      '","' +
      this.newDipendente.email +
      '","' +
      this.newDipendente.rfid +
      '")';
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.newDipendente.id = res.data.insertId;
          this.dataSet.push(this.newDipendente);

          this.newDipendente = {
            id: "",
            code: "",
            name: "",
            surname: "",
            company: "",
            email: "",
            rfid: "",
          } as Dipendente;
          this.newCodeError = "validating";

          this.message.success("Nuovo inserimento creato con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: this.g.normalTime }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  saveEdit(id: string): void {
    const data: Dipendente = this.editCache[id].data;
    const index = this.dataSet.findIndex((item) => item.id === id);

    const check = this.dataSet.findIndex((item) => item.code === data.code);
    if (check !== -1 && check !== index) {
      this.notification.error(
        "Codice già esistente",
        "Attenzione: il codice inserito è già stato utilizzato.",
        { nzDuration: this.g.fastTime }
      );
      return;
    }

    this.dataSet[index] = this.editCache[id].data;
    this.editCache[id].edit = false;

    const query: string =
      'UPDATE chk_users SET `code`="' +
      data.code +
      '", `name`="' +
      data.name +
      '", `surname`="' +
      data.surname +
      '", `company`="' +
      data.company +
      '", `email`="' +
      data.email +
      '", `rfid`="' +
      data.rfid +
      '" where `id`=' +
      data.id;
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.message.success("Modifica completata con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: this.g.normalTime }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
  deleteRow(id: string): void {
    const index = this.dataSet.findIndex((item) => item.id === id);
    const query: string =
      'DELETE FROM chk_users WHERE `code`= "' + this.dataSet[index].code + '"';
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.dataSet.splice(index, 1);
          this.message.success("Cancellazione completata con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: this.g.normalTime }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }

  updateEditCache(): void {
    if (this.dataSet != null) {
      this.dataSet.forEach((item) => {
        if (!this.editCache[item.id]) {
          this.editCache[item.id] = {
            edit: false,
            data: item,
          };
        }
      });
    }
    this.displayData = [...this.dataSet];
  }
}
